module.exports = __webpack_public_path__ + "static/media/Japan.77f4b1c3.svg";